<template>
  <div class="content w-full">
    <TopNavbar />
    <div class="page-content">
      <DynamicVisibility  ref="dynamicVisibility">
        <template #primary>
          <DevelopersOverviewComponent :goBackVisible="true" @toggle-visibility="toggleVisibility" />
        </template>

        <template #secondary>
          <LibraryComponent />
        </template>
      </DynamicVisibility>
    </div>
  </div>
</template>

<script>
import TopNavbar from "@/components/user/layout/TopNavbar.vue";
import DevelopersOverviewComponent from "@/components/user/viewComponent/developers/DevelopersOverviewComponent.vue";
import DynamicVisibility from "@/components/custom/visibility/DynamicVisibility.vue";
import LibraryComponent from "@/components/user/viewComponent/developers/LibraryComponent.vue";

export default {
  name: "DeveloprsViewComponent",
  components: {
    TopNavbar,
    DevelopersOverviewComponent,
    DynamicVisibility,
    LibraryComponent,
  },
  methods: {
    toggleVisibility(visible) {
      this.$refs.dynamicVisibility.toggle(visible);
    },
  },
};
</script>

<style></style>
